export default function Loading() {
    return <div className="loader-wrapper">
        <div className="loader-icon">
            <img src="https://gmschurch-assets-2.b-cdn.net/loader/Tail-3s-64px.svg" alt="loading" />
            <div>
                Please wait...
            </div>
        </div>
    </div>;
}